import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './components'
import './libs/main.scss'

ReactDOM.render(
  <div>
    <App />
  </div>,
  document.getElementById('root')
);

